export enum EIcons {
  video = 'ion-social-youtube',
  chat = 'ion-chatbubbles',
  interactive = 'ion-stats-bars',
  listeners = 'ion-speakerphone',
  group = 'ion-ios-people',
  anketa = 'ion-edit',
  addFile = 'ion-archive',
  help = 'ion-help-circled',
  presentation = 'ion-ipad',
  about = 'ion-eye',
  ticket = 'ion-document',
  final = 'ion-trophy',
  home = 'ion-home',
  logo = 'st1',
  close = 'ion-close',
  search = 'ion-ios-search-strong',
  plus = 'ion-ios-plus-empty',
  certificate = 'ion-android-document',
}
